import { NgClass } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { Store, select } from '@ngrx/store';
import { ImageCdnSrcDirective } from '@polaris-customerweb/sharedcomponents.shared';
import { combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { AppState } from 'src/app/models/app-state';
import { RideTypeService } from 'src/app/services/ride-type.service';
import { selectIsShowingSatellite } from 'src/app/state/map/layer-visibility/layer-visibility.reducer';

@Component({
    imports: [ImageCdnSrcDirective, MatDialogModule, NgClass],
    selector: 'rdx-trail-legend',
    standalone: true,
    styleUrls: ['./trail-legend.component.scss'],
    templateUrl: './trail-legend.component.html',
})
export class TrailLegendComponent implements OnDestroy, OnInit {
    @Input() legendUrl: string;

    isOrv: boolean;
    dirtBikeImg: string;
    atvImg: string;
    sxs50Img: string;
    sxsImg: string;
    otherImg: string;
    designatedPavedImg: string;
    designatedUnpavedImg: string;
    closedImg: string;
    trunkImg: string;
    trailImg: string;
    clubTrailImg: string;
    openRideArea: string;
    unmaintainedImg: string;

    private isDestroyed = false;

    constructor(
        private store: Store<AppState>,
        private rideTypeService: RideTypeService
    ) {}

    ngOnInit() {
        combineLatest([
            this.store.pipe(select(selectIsShowingSatellite)),
            this.rideTypeService.rideType$,
        ])
            .pipe(takeWhile(() => !this.isDestroyed))
            .subscribe(([isSatellite, selectedRideType]) => {
                const rideType = (selectedRideType || 'orv').toLowerCase();
                this.isOrv = rideType === 'orv';
                this.closedImg =
                    '/assets/icons/map-legend-icons/icon-closed-trail.svg';

                if (isSatellite) {
                    if (this.isOrv) {
                        this.dirtBikeImg =
                            '/assets/icons/map-legend-icons/orv/icon-offroadtrails-ohm-sat.svg';
                        this.atvImg =
                            '/assets/icons/map-legend-icons/orv/icon-offroadtrails-atv-sat.svg';
                        this.sxs50Img =
                            '/assets/icons/map-legend-icons/orv/icon-offroadtrails-rov50-sat.svg';
                        this.sxsImg =
                            '/assets/icons/map-legend-icons/orv/icon-offroadtrails-rov-sat.svg';
                        this.otherImg =
                            '/assets/icons/map-legend-icons/orv/icon-offroadtrails-other-sat.svg';
                        this.designatedPavedImg =
                            '/assets/icons/map-legend-icons/orv/icon-offroadtrails-des-paved-sat.svg';
                        this.designatedUnpavedImg =
                            '/assets/icons/map-legend-icons/orv/icon-offroadtrails-des-unpaved-sat.svg';
                        this.unmaintainedImg =
                            '/assets/icons/map-legend-icons/orv/icon-offroadtrails-unmaintained-sat.svg';
                        this.openRideArea =
                            '/assets/icons/open-ride-area-off-road-sat.svg';
                    } else {
                        this.trunkImg =
                            '/assets/icons/map-legend-icons/sno/icon-snowtrails-trunk-sat.svg';
                        this.trailImg =
                            '/assets/icons/map-legend-icons/sno/icon-snowtrails-trail-sat.svg';
                        this.clubTrailImg =
                            '/assets/icons/map-legend-icons/sno/icon-snowtrails-clubtrail-sat.svg';
                        this.unmaintainedImg =
                            '/assets/icons/map-legend-icons/sno/icon-snowtrails-unmaintained-sat.svg';
                        this.openRideArea =
                            '/assets/icons/open-ride-area-snow-sat.svg';
                    }
                } else {
                    if (this.isOrv) {
                        this.dirtBikeImg =
                            '/assets/icons/map-legend-icons/orv/icon-offroadtrails-ohm.svg';
                        this.atvImg =
                            '/assets/icons/map-legend-icons/orv/icon-offroadtrails-atv.svg';
                        this.sxs50Img =
                            '/assets/icons/map-legend-icons/orv/icon-offroadtrails-rov50.svg';
                        this.sxsImg =
                            '/assets/icons/map-legend-icons/orv/icon-offroadtrails-rov.svg';
                        this.otherImg =
                            '/assets/icons/map-legend-icons/orv/icon-offroadtrails-other.svg';
                        this.designatedPavedImg =
                            '/assets/icons/map-legend-icons/orv/icon-offroadtrails-des-paved.svg';
                        this.designatedUnpavedImg =
                            '/assets/icons/map-legend-icons/orv/icon-offroadtrails-des-unpaved.svg';
                        this.unmaintainedImg =
                            '/assets/icons/map-legend-icons/orv/icon-offroadtrails-unmaintained.svg';
                        this.openRideArea =
                            '/assets/icons/open-ride-area-off-road.svg';
                    } else {
                        this.trunkImg =
                            '/assets/icons/map-legend-icons/sno/icon-snowtrails-trunk.svg';
                        this.trailImg =
                            '/assets/icons/map-legend-icons/sno/icon-snowtrails-trail.svg';
                        this.clubTrailImg =
                            '/assets/icons/map-legend-icons/sno/icon-snowtrails-clubtrail.svg';
                        this.unmaintainedImg =
                            '/assets/icons/map-legend-icons/sno/icon-snowtrails-unmaintained.svg';
                        this.openRideArea =
                            '/assets/icons/open-ride-area-snow.svg';
                    }
                }
            });
    }

    ngOnDestroy() {
        this.isDestroyed = true;
    }
}
